<template>
	<div>
		<!-- Add/Edit curso -->
		<FormCurso
			:curso="cursoEdit"
			:typeForm="typeForm"
			@changeTypeForm="changeTypeForm"
			v-if="showFormCurso"
		></FormCurso>

		<v-row>
			<v-col cols="12" v-if="XMLHttpRequest">
				
				<v-btn @click="formCurso(0, null)" color="success">
					<v-icon small left>fal fa-plus</v-icon> Curso
				</v-btn>
				<v-btn @click="archive=!archive" :color="(archive)?'orange lighten-1':'grey'" class="btn-square float-right" title="Arquivo" dark>
					<v-icon small>fal fa-archive</v-icon>
				</v-btn>
			</v-col>
		</v-row>
		<v-row v-if="cursos">
			<v-col
				cols="12"
				lg="6"
				md="6"
				sm="12"
				xs="12"
				class="d-flex flex-column"
				v-for="curso in cursos"
				:key="curso.id"
			>
				<v-card :color="(archive)?'warning darken-1':'green darken-1'" dark class="flex d-flex flex-column">
					<v-card-actions>
						<v-btn
							outlined
							color="white"
							:to="{ name: 'Aulas', params: { id: curso.id } }"
							><v-icon small left>fal fa-chalkboard-teacher</v-icon> Aulas</v-btn
						>
						<v-spacer></v-spacer>
						<v-btn small fab icon title="Editar" @click="formCurso(1, curso)"
							><v-icon small>fal fa-pen-alt</v-icon></v-btn
						>
					</v-card-actions>
					<v-card-title class="headline">{{ curso.nome }}</v-card-title>
					<v-card-text v-if="curso.descricao" v-html="curso.descricao" class="ql-editor-custom ql-editor-custom-dark"></v-card-text>
				</v-card>
			</v-col>
		</v-row>
		<v-alert color="blue-grey darken-1" dark border="right" icon="fas fa-empty-set" v-else>
			Sem dados cadastrados
		</v-alert>
	</div>
</template>

<script>
import { mapState } from 'vuex'

import FormCurso from '@/components/admin/FormCurso'

export default {
	components: {
		FormCurso,
	},
	data() {
		return {
			server: 'curso',
			cursos: [],
			archive: false,
			showFormCurso: false,
			cursoEdit: {},
			video: {
				cursoId: null,
			},
		}
	},
	computed: {
		...mapState(['user', 'XMLHttpRequest']),
	},
	created() {
		this.getData()
	},
	watch: {
		archive(){
			this.getData()
		}
	},
	methods: {
		getData() {
			let formData = new FormData()
			formData.append('menu', this.server)
			formData.append('function', 'get_' + this.server)
			formData.append('user_id', this.user.id)
			formData.append('archive', this.archive)
			let vd = this

			this.$axiosPost
				.post('functions.php', formData, {
					headers: { Authorization: this.user.token },
				})
				.then(function(response) {
					if (response.data.error === 0) {
						vd.cursos = response.data.cursos
					} else {
						vd.$store.dispatch('errorServer', {
							data: response.data,
							destino: vd.$route.path,
						})
					}
				})
				.catch(function(response) {
					console.log('ERRO!! ' + response)
				})
		},
		formCurso(type, curso) {
			this.typeForm = type
			if (type === 0) {
				this.cursoEdit = {}
			} else {
				this.cursoEdit = Object.assign({}, curso)
			}
			this.showFormCurso = true
			setTimeout(() => {
				this.$store.dispatch('dialogCurso', { value: true })
			}, 300)
		},
		changeTypeForm(value) {
			this.typeForm = value.typeForm
			if (value.hideForm == 'curso') {
				this.showFormCurso = false
			}
			this.getData()
		},
	},
}
</script>
